// extracted by mini-css-extract-plugin
export default {"buttonContainer":"DeleteSubProgramDialog_buttonContainer__crgRU","buttonText":"DeleteSubProgramDialog_buttonText__3Y67j","cancelText":"DeleteSubProgramDialog_cancelText__o9KmX"};